export default "__VITE_ASSET__Bqm4lOwj__"